export const
    THROW_ERROR = "THROW_ERROR",
    CLEAR_ERROR = "CLEAR_ERROR",
    CLEAR_COMPANY_ERROR = 'CLEAR_COMPANY_ERROR',
    CLEAR_COMPLAINT_ERROR = 'CLEAR_COMPLAINT_ERROR',
    CLEAR_COMPLAINT_POSITION_ERROR = 'CLEAR_COMPLAINT_POSITION_ERROR',
    CLEAR_CUSTOMER_ERROR = 'CLEAR_CUSTOMER_ERROR',
    THROW_COMPANY_ERROR = 'THROW_COMPANY_ERROR',
    THROW_COMPLAINT_ERROR = 'THROW_COMPLAINT_ERROR',
    THROW_COMPLAINT_POSITION_ERROR = 'THROW_COMPLAINT_POSITION_ERROR',
    THROW_CUSTOMER_ERROR = 'THROW_CUSTOMER_ERROR';


// WEBPACK FOOTER //
// ./src/types/Error.js